import React, { useMemo } from 'react';
import { Text, type TextStyle } from 'react-native';
import { Flex, Typography } from '@banhala/ui-kit';
import { isWeb } from 'shared/src/utils';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { isSalesMethodIsPreOrder } from '../../../utils/isSalesMethodIsPreOrder';
export const useDeliveryWarningMessage = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { data: goodsDetail } = useGoodsDetail();

  return useMemo(() => {
    if (!goodsBasic) return '배송 출발 이후 배송 기간은 2~3일 소요됩니다.';

    if (isSalesMethodIsPreOrder(goodsBasic)) {
      return (
        <Flex.Column gap={4} flex={1}>
          <Typography type={'body3'} color={'content_tertiary'}>
            최소 수량 미달 시 판매기간 종료 후{' '}
            <Typography type={'subtitle3'} color={'content_tertiary'}>
              취소될 수 있습니다.
            </Typography>
          </Typography>
          <Text
            textBreakStrategy="highQuality"
            lineBreakStrategyIOS="standard"
            style={isWeb ? ({ wordBreak: 'keep-all' } as TextStyle) : undefined}
          >
            <Typography type={'body3'} color={'content_tertiary'}>
              프리오더 상품 여러 개 주문 시,{' '}
              <Typography type={'subtitle3'} color={'content_tertiary'}>
                가장 늦은 출발예정일을 기준으로 함께 발송
              </Typography>
              됩니다.
            </Typography>
          </Text>
        </Flex.Column>
      );
    }

    const deliveryType = goodsBasic.delivery_type_info.delivery_type;
    const isDeliveredByAbly = goodsBasic.market.is_delivered_by_ably;

    if (deliveryType === 'shak') {
      return isDeliveredByAbly
        ? '일반 배송 옵션은 배송 출발일이 다를 수 있습니다.'
        : '마켓 직접 배송 옵션은 배송 출발일이 다를 수 있습니다.';
    }

    if (deliveryType === 'today') {
      return '일반 배송 옵션은 배송 출발일이 다를 수 있습니다.';
    }
    if (goodsDetail?.goods.send_expectation_info?.is_market_provided) {
      return (
        <Typography type={'body3'} color={'content_tertiary'}>
          배송 출발 이후 배송 기간은 2~3일 소요됩니다.{'\n'}
          출발 예정 정보는{' '}
          <Typography type={'subtitle3'} color={'content_tertiary'}>
            판매자 지정 날짜
          </Typography>
          이며 변경될 수 있습니다.
        </Typography>
      );
    }

    return '배송 출발 이후 배송 기간은 2~3일 소요됩니다.';
  }, [
    goodsBasic,
    goodsDetail?.goods.send_expectation_info?.is_market_provided,
  ]);
};
